<div class="crown-light-blue-background-hover menu-icon" #HamburgerMenuIcon>
	<button id="hamburger-menu-icon" class="no-style" (click)="ToggleMenu()">
		<span class="material-icons-outlined">menu</span>
	</button>
</div>
<nav class="navbar-container flex-row" [class.slide-in-left]="IsHamburgerMenuOpen" [class.open-menu-container]="IsHamburgerMenuOpen" #NavigationMenu>
	<crownx-menu-items [IsHamburgerMenuOpen]="IsHamburgerMenuOpen" [ngClass]="{ 'hamburger-open': IsHamburgerMenuOpen, 'hamburger-closed': !IsHamburgerMenuOpen }" (MenuItemActionTriggered)="HandleMenuItemActionTriggered()"></crownx-menu-items>
	<div class="user-actions" [class.visible-user-actions]="IsHamburgerMenuOpen">
		<div class="user-info">
			<div class="username" id="menu-username">{{UserName}}</div>
			<div *ngIf="CompanyName" id="menu-company-name">{{CompanyName | uppercase}}</div>
		</div>
		<div class="open-menu-item crown-light-blue-background-hover" *ngIf="HasMultipleCrownIds">
			<a (click)="ChangeCompany()">
				<span class="navbar-text">Switch</span>
			</a>
		</div>
		<div class="open-menu-item crown-light-blue-background-hover">
			<a (click)="Logout()" id="logout">
				<span class="navbar-text">Logout</span>
			</a>
		</div>
	</div>
</nav>
<crown-x-dialog #VersionUpdateDialog class="version-update-dialog" DialogTitle="Version Update" (OkButtonClick)="OnVersionUpdateDialogOkayClick()">
	There are currently no version updates available.
</crown-x-dialog>
